import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import ActivityPageHeader from '../../components/ActivityPageHeader';
import { useActivity } from '../../hooks';
import { ProfessorActivity } from '../../types';

import useActivityDetailsPageTabs from './useActivityDetailsPageTabs';

const ActivityDetailsPage = () => {
  const { courseId, activityId } = useParams<{ courseId: string; activityId: string }>();
  const history = useHistory();

  const { activity, loading } = useActivity({ courseId, activityId });
  const { tabs, onGoToTab, activePage } = useActivityDetailsPageTabs();

  const handleEditActivity = useCallback(
    (activity: ProfessorActivity) => {
      history.push(`/${courseId}/activities/${activityId}/edit`);
    },
    [history, courseId, activityId]
  );

  return (
    <Box>
      <BackButton href={`/${courseId}/activities`} title={activity?.name} subtitle="Tareas" />
      <ActivityPageHeader
        activity={activity}
        loading={loading}
        onGoToTab={onGoToTab}
        tabs={tabs}
        activeTab={activePage?.tab}
        onEditActivity={handleEditActivity}
      />
      {activePage?.page && <Box mt={2}>{activePage?.page}</Box>}
    </Box>
  );
};

export default ActivityDetailsPage;
